import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function BezopasnostYoybuy() {
  return <ArticleLayout slug="bezopasnost-yoybuy" />;
}